import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import {  map, capitalize } from "lodash";
//import Lead from "./Lead";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { addClientAddListing, getClientAddListing } from "../../store/addlisting/actions"
import CurrencyFormat from 'react-currency-format';
import Switch from "react-switch"
import typeView from "../../assets/images/type-view.png"
import uploadView from "../../assets/images/icons/upload.png"
import gridView from "../../assets/images/grid-view.png"
import downloadView from "../../assets/images/icons/down.png"
import compareImg from "../../assets/images/icons/compare.png"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Tooltip
} from "reactstrap"

class addListing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
    this.toggle = this.toggle.bind(this);
    this.handleAddListingSubmit = this.handleAddListingSubmit.bind(this)
  }
  toggle () {
    this.setState({
      open: !this.state.open
    })
  }
  handleAddListingSubmit(value){
    
    this.props.addClientAddListing(value, this.props.history);

  }
  componentDidMount() {
    const {  onGetClientAddListing } = this.props;
   
    onGetClientAddListing(localStorage.getItem('userId'),localStorage.getItem('agentId'))
   
}
handleChange = (activeStatus, itemId) => {
    
};
  render() {
    const { addListings, loading } = this.props;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Compare  | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Buyer")}
              breadcrumbItem={this.props.t("Compare")}
            /> */}
            <Row>
              
              
              <Col xl="12">
              
			  <Row>
				<Col sm="12">
					 <Card className="mini-stats-wid"> 
                    <CardBody>
                      
                    <div className="row gy-2 gx-4  mb20">
                      <div className="col-sm-3 float-start">
                        <div className="col-sm-12">
                          <h4 className="compare-text">Compare Listings </h4>
                        </div>
                      </div>
                      <div className="col-sm-8 ">
                        <div className="row float-end">
                          <div className="col-sm-auto">
                            
                            <Link to='/compare-not-match'><Button className="btn btn-primary w-md not-match">Not Match</Button></Link>
                          </div>

                          <div className="col-sm-auto">
                            <Link  to='/compare-match'><Button className="btn btn-primary w-md match">Match</Button></Link>
                          </div>
                        
                          <div className="col-sm-auto">
                            <Link  to='/compare-nice-to-have'><Button className="btn btn-primary w-md nice-to-have">Nice to have</Button></Link>
                          </div>
                          
                          
                        </div>
                      </div>
                    </div>
        <div className="clearfix"></div>
        
					  <div className="table-responsive">
					  	<table className="table mb-0 table">
                <thead>
                  <tr>
                  <th></th>
                  <th className="text-center">W4480580<br/><span className="text-danger ">$1,150,000</span></th>
                  <th className="text-center">W4521018<br/><span className="text-danger ">$1,210,000</span></th>
                  <th className="text-center">W4547688<br/><span className="text-danger ">$1,190,000</span></th>
                  </tr>
                  <tr>
                  <th className=" text-danger text-decoration-underline">FEATURES</th>
                  <th className="text-center">6845 Golden Hills Way Mississauga</th>
                  <th className="text-center">618 Deckhouse Crt Mississauga</th>
                  <th className="text-center">7168 Lantern Fly Hllw Mississauga</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td >Bedroom(s)</td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">3</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">2.5</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">3</Button></td>
                  </tr>

                  <tr>
                    <td >Bathrom(s)</td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">2</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">2</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">2</Button></td>
                  </tr>

                  <tr>
                    <td >Desired area(sq. ft)</td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">2150</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">2000</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">2000</Button></td>
                  </tr>

                  <tr>
                    <td >Close to school</td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                  </tr>

                  <tr>
                    <td >Close to main highway</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                  </tr>

                  <tr>
                    <td >Close to grocery store</td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                  </tr>

                  <tr>
                    <td >Close to shopping mall</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">N</Button></td>
                  </tr>

                  <tr>
                    <td >Close to palce of worship</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md match">Y</Button></td>
                  </tr>

                  <tr>
                    <td >close to park</td>
                    <td className="text-center"><Button className="btn btn-primary w-md nice-to-have">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">Y</Button></td>
                  </tr>

                  <tr>
                    <td >Swimming pool</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">Y</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">N</Button></td>
                  </tr>
                 

                  <tr>
                    <td className="text-danger text-decoration-underline"><b>DISTANCE</b></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                  </tr>

                  <tr>
                    <td >Office</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">12km</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">10.5km</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">6.3km</Button></td>
                  </tr>

                  <tr>
                    <td >GYM</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">2.1km</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">9.5km</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">5.7km</Button></td>
                  </tr>

                  <tr>
                    <td >Armys school</td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">4.4km</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">1.5km</Button></td>
                    <td className="text-center"><Button className="btn btn-primary w-md not-match">3.6km</Button></td>
                  </tr>

             
                                
                </tbody>          
					  	</table>
						</div>
					</CardBody>
					</Card>
				</Col>
			</Row>
			
			
            </Col>
            
            </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
addListing.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  addClientAddListing:PropTypes.func,
  addListings:PropTypes.array,
  onGetClientAddListing:PropTypes.func,
  loading:PropTypes.object

}
const mapStateToProps = ({ addListing }) => (
  {
    addListings:addListing.addListings,
    loading:addListing.loading

  })
const mapDispatchToProps = dispatch => ({
  
  addClientAddListing: (data) => dispatch(addClientAddListing(data)),
  onGetClientAddListing:(clientId, agentId) => dispatch(getClientAddListing(clientId, agentId))
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(addListing))
